/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MetaInfoFile
 */
export interface MetaInfoFile {
    /**
     * 
     * @type {number}
     * @memberof MetaInfoFile
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetaInfoFile
     */
    'creator'?: string;
    /**
     * 
     * @type {number}
     * @memberof MetaInfoFile
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetaInfoFile
     */
    'type': MetaInfoFileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MetaInfoFile
     */
    'base64Content': string;
}

export const MetaInfoFileTypeEnum = {
    Image: 'image',
    Soundfile: 'soundfile'
} as const;

export type MetaInfoFileTypeEnum = typeof MetaInfoFileTypeEnum[keyof typeof MetaInfoFileTypeEnum];


